import AddIcon from "../../../components/Common/SvgIcons/AddIcon";
import ActiveUserIcon from "../../../components/Common/SvgIcons/DashBoardIcons/ActiveUserIcon";
import CompletedCoursesIcon from "../../../components/Common/SvgIcons/DashBoardIcons/CompletedCoursesIcon";
import DistibuteIcon from "../../../components/Common/SvgIcons/DashBoardIcons/DistibuteIcon";
import NotStartedCoursesIcon from "../../../components/Common/SvgIcons/DashBoardIcons/NotStartedCoursesIcon";
import PublishedCoursesIcon from "../../../components/Common/SvgIcons/DashBoardIcons/PublishedCoursesIcon";
import ReportsIcon from "../../../components/Common/SvgIcons/DashBoardIcons/ReportsIcon";
import TotalUsersIcon from "../../../components/Common/SvgIcons/DashBoardIcons/TotalUsersIcon";
import TotalUsers from "../../../components/Common/SvgIcons/DashBoardIcons/TotalUsersIcon";
import TrendingCoursesIcon from "../../../components/Common/SvgIcons/DashBoardIcons/TrendingCoursesIcon";
import { roleMenuList } from "../../roleMenuList";
import { colors } from "../../stripeColors";
import { distribute } from "../distribute/distribute";
import { createShotclasses } from "../manage/createShotclasses";
import { reports } from "../reports/reports";

export const dashboard = {
  name: "Home",
  path: (tenantName) => `/${tenantName}/home`,
  buttons: (navigate, tenantName) => [
    {
      key: 1,
      label: createShotclasses.label,
      path: createShotclasses.path(null, null, tenantName),
      icon: createShotclasses.icon,
      color: colors.blushGreen,
      onClick: () => navigate(createShotclasses.path(null, null, tenantName)),
      menu: {
        roleMenu: roleMenuList?.MANAGE?.CREATE_SHOTCLASS,
        MSOMMenu: "",
      },
    },
    {
      key: 2,
      label: distribute.name,
      path: distribute.path,
      icon: distribute.icon,
      color: colors.purple,
      width: 22,
      onClick: () => navigate(distribute.path(tenantName)),
      menu: {
        roleMenu: roleMenuList?.DISTRIBUTE,
        MSOMMenu: "",
      },
    },
    {
      key: 3,
      label: reports.name + " & Analytics",
      path: reports.path,
      icon: ReportsIcon,
      color: colors.red,
      onClick: () =>
        navigate(`/${tenantName}/reports/tabularReport/userTabularReport`),
    },
  ],
  tiles: (
    tenantName,
    userClassInfo,
    classInfo,
    trendingClassInfo,
    userStatusData,
    publishedByMeData,
    publishedByOthersData
  ) => [
    {
      key: 1,
      label: "Published Courses",
      path: dashboard.path(tenantName) + "/publishedCourses",
      value: publishedByMeData + publishedByOthersData || 0,
      color: colors.green,
      icon: (fill) => <PublishedCoursesIcon fill={fill} />,
      isHover: false,
    },
    {
      key: 2,
      label: "Total Users",
      path: dashboard.path(tenantName) + "/trendingCourses",
      value: userStatusData[0] + userStatusData[1] || 0,
      color: colors.purple,
      icon: (fill) => <TotalUsersIcon fill={fill} />,
      isHover: false,
    },
    {
      key: 3,
      label: "Active Users",
      path: dashboard.path(tenantName) + "/trendingCourses",
      value: userStatusData[0] || 0,
      color: colors.red,
      icon: (fill) => <ActiveUserIcon fill={fill} />,
      isHover: false,
    },
    // {
    //   key: 2,
    //   label: "Trending Courses",
    //   path: dashboard.path(tenantName) + "/trendingCourses",
    //   value: trendingClassInfo?.TotalRows || 0,
    //   color: colors.purple,
    //   icon: (fill) => <TrendingCoursesIcon fill={fill} />,
    //   isHover: false,
    // },
    // {
    //   key: 3,
    //   label: "Completed Courses",
    //   path: dashboard.path(tenantName) + "/completedCourses",
    //   value: userClassInfo?.Completed || 0,
    //   color: colors.red,
    //   icon: (fill) => <CompletedCoursesIcon fill={fill} />,
    //   isHover: false,
    // },
    // {
    //   key: 4,
    //   label: "Not Started Courses",
    //   path: dashboard.path(tenantName) + "/notStartedCourses",
    //   // value: userClassInfo?.NotStartedYet || 0,
    //   value: classInfo?.NotStartedYet || 0,
    //   color: colors.orange,
    //   icon: (fill) => <NotStartedCoursesIcon fill={fill} />,
    //   isHover: false,
    // },
  ],
};
